export default __webpack_public_path__ + "static/media/open-edx-api.272b4dc2.png";